var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54879 13.6135L14.0958 8.06646C13.1625 7.67682 12.315 7.10753 11.6013 6.39096C10.8844 5.67712 10.3148 4.82929 9.92504 3.89571L4.37804 9.44271C3.94529 9.87546 3.72854 10.0922 3.54254 10.3307C3.32287 10.6122 3.13451 10.9167 2.98079 11.239C2.85104 11.512 2.75429 11.803 2.56079 12.3835L1.53929 15.4457C1.49228 15.5859 1.4853 15.7365 1.51915 15.8804C1.553 16.0244 1.62633 16.156 1.7309 16.2606C1.83547 16.3652 1.96713 16.4385 2.11108 16.4724C2.25504 16.5062 2.40558 16.4992 2.54579 16.4522L5.60804 15.4307C6.18929 15.2372 6.47954 15.1405 6.75254 15.0107C7.07504 14.857 7.37954 14.6687 7.66079 14.449C7.89929 14.263 8.11604 14.0462 8.54879 13.6135ZM15.6348 6.52746C16.1879 5.97438 16.4986 5.22425 16.4986 4.44209C16.4986 3.65992 16.1879 2.90979 15.6348 2.35671C15.0817 1.80363 14.3316 1.49292 13.5494 1.49292C12.7673 1.49292 12.0171 1.80363 11.464 2.35671L10.7988 3.02196L10.8273 3.10521C11.1551 4.04325 11.6916 4.89464 12.3963 5.59521C13.1178 6.32099 13.999 6.86804 14.9695 7.19271L15.6348 6.52746Z",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledEdit);
export default __webpack_public_path__ + "static/media/disabled-edit.82e4dcc0d4d77a0f0aecd3107fe15a9f.svg";
export { ForwardRef as ReactComponent };